<template>
    <div>
        <div class="article" v-for="post in posts" :key="post.id">
            <div class="row">
                <div class="col-sm-4 col-12">
                    <a :href="root.url('post_view', { slug: post.slug, id: post.id })">
                        <img :alt="post.title"
                             :src="root.asset('bundles/ornweb/img/facebook-share.png')"
                             :data-srcset="(post.image ? post.image.sizes.small : root.asset('bundles/ornweb/img/facebook-share.png')) + ' 1x,' + (post.image ? post.image.sizes.medium : root.asset('bundles/ornweb/img/facebook-share.png')) + ' 2x'"
                             :data-src="post.image ? post.image.sizes.small : root.asset('bundles/ornweb/img/facebook-share.png')"
                             class="lazyload avatar-img rounded img-fluid">
                    </a>
                </div>
                <div class="col">
                    <h4 class="card-title mb-1 mt-2 mt-sm-0">
                        <a :href="root.url('post_view', { slug: post.slug, id: post.id })" class="name text-dark">{{ post.title }}</a>
                    </h4>
                    <p class="text-muted mb-0 small">
                        <span v-if="isSectionShow && post.section"><a :href="root.url('post_section', { slug: post.section.slug })" class="text-danger">{{ post.section.name }}</a> &middot;</span>
                        <span v-if="isCategoryShow && post.category"><a :href="root.url('post_category', { slug: post.category.slug })" class="text-danger">{{ post.category.name }}</a> &middot;</span>
                        <span v-if="isAuthorShow && post.author"><post-author :author="post.author"></post-author> &middot;</span>
                        <time :datetime="root.moment(post.publish_at).format('YYYY-MM-DD HH:mm:ss')">{{ root.moment(post.publish_at).fromNow() }}</time>
                    </p>
                    <p class="text-muted mt-2 mb-0 small d-none d-sm-block">
                        {{ post.excerpt }}
                    </p>
                </div>
            </div>
            <hr />
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue'
import PostAuthor from './PostAuthor.vue'

const props = defineProps({
    posts: {
        type: Array,
        required: true
    },
    isSectionShow: {
        type: Boolean,
        default: true
    },
    isCategoryShow: {
        type: Boolean,
        default: true
    },
    isAuthorShow: {
        type: Boolean,
        default: true
    }
})

const root = inject('root')
</script>

<style scoped>
</style>
